var React = require('react');

function ArrowLeftOrange (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.37127 0H3.96073L0 6.9984L3.96073 13.9968H7.37127L3.41054 6.9984L7.37127 0Z","fill":"#F18841"}));
}

ArrowLeftOrange.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"};

module.exports = ArrowLeftOrange;

ArrowLeftOrange.default = ArrowLeftOrange;
